import type { PinterestState } from './Pinterest.types';

export const INIT_STATE: PinterestState = {
  adAccounts: [],
  adAccountStatuses: {},
  authenticationUrl: '',
  loading: false,
};
